module.exports = __webpack_public_path__ + "img/2017.2e087e4b.jpg";